<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div style="width: 100%; height: 100%; position: relative">
    <!--Fly to targets menu-->
    <div class="map_control-btns">
      <v-menu
        offset-y
        :nudge-width="200"
        transition="slide-y-transition"
        :close-on-content-click="false"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-badge
            :color="eventsBadgeColor"
            overlap
            bottom
            left
            :content="markers.length"
            class="map_targets_btn"
          >
            <v-btn
              color="primary"
              dark
              v-bind="attrs"
              class="mb-2"
              v-on="on"
              fab
            >
              <v-icon>fa-calendar-week</v-icon>
            </v-btn>
          </v-badge>
        </template>
        <v-card style="position: relative">
          <v-list dense>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title> Events list </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item-group
              v-model="selectedEvent"
              color="primary"
              v-if="markers && markers.length > 0"
              class="map_events_list"
            >
              <v-list-item v-for="m in markers" :key="m.meetId">
                <v-menu
                  bottom
                  :offset-x="true"
                  left
                  transition="slide-y-transition"
                  open-on-hover
                  nudge-left="25"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-list-item-content
                      @click="fly(m)"
                      v-on="on"
                      v-bind="attrs"
                    >
                      <div class="hover-item-content">
                        <v-list-item-icon>
                          <v-icon>fa-calendar-day</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title
                          v-text="m.meetName"
                        ></v-list-item-title>
                      </div>
                    </v-list-item-content>
                  </template>
                  <MapEventDetails :data="m" />
                </v-menu>
              </v-list-item>
            </v-list-item-group>
            <v-list-item v-else>
              <v-list-item-content>
                <v-list-item-title>
                  <v-alert
                    text
                    outlined
                    color="#004c8c"
                    icon="fa-exclamation-triangle"
                    class="mt-4"
                  >
                    There are currently no active events. <br />
                    This may be due to your use of filters.
                  </v-alert>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-menu>
      <!--Filter menu-->
      <v-menu
        offset-y
        :nudge-width="200"
        style="z-index: 2000"
        transition="slide-y-transition"
        :close-on-content-click="false"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on" fab>
            <v-icon>fa-filter</v-icon>
          </v-btn>
        </template>
        <v-card>
          <v-list>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>
                  Filter through the events
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>

          <v-divider></v-divider>
          <!--Event name filter item-->
          <v-list>
            <v-list-item>
              <v-list-item-title>
                <v-text-field
                  v-model.trim="filtersObject.event"
                  label="Event name"
                  outlined
                  dense
                  hide-details
                  class="mt-2"
                >
                  <template v-slot:append>
                    <v-icon @click="filtersObject.event = ''">
                      fa-times
                    </v-icon>
                  </template>
                </v-text-field>
              </v-list-item-title>
            </v-list-item>
            <!--League filter item-->
            <v-list-item>
              <v-list-item-title>
                <v-select
                  v-model.trim="filtersObject.league"
                  :items="leagueNames"
                  label="League name"
                  item-value="node.name"
                  item-text="node.name"
                  outlined
                  hide-details
                  dense
                  class="mt-2"
                >
                  <template v-slot:append>
                    <v-icon @click="filtersObject.league = ''">fa-times</v-icon>
                  </template>
                </v-select>
              </v-list-item-title>
            </v-list-item>
            <!--Sport type filter-->
            <v-list-item>
              <v-list-item-title>
                <v-select
                  v-model.trim="filtersObject.sport"
                  :items="getFiltersList('SPORT_TYPE')"
                  label="Sport type"
                  item-value="node.valName"
                  item-text="node.valName"
                  outlined
                  hide-details
                  dense
                  class="mt-2"
                >
                  <template v-slot:append>
                    <v-icon @click="filtersObject.sport = ''">fa-times</v-icon>
                  </template>
                </v-select>
              </v-list-item-title>
            </v-list-item>
            <!--Country filter item-->
            <v-list-item>
              <v-list-item-title>
                <v-select
                  v-model="filtersObject.country"
                  :items="getFiltersList('COUNTRY_LIST')"
                  label="Country name"
                  item-value="node.valId"
                  item-text="node.valDesc"
                  outlined
                  hide-details
                  dense
                  class="mt-2"
                >
                  <template v-slot:append>
                    <v-icon @click="filtersObject.country = ''"
                      >fa-times</v-icon
                    >
                  </template>
                </v-select>
              </v-list-item-title>
            </v-list-item>
            <!--Tags filter-->
            <v-list-item>
              <v-list-item-title>
                <v-select
                  v-model="filtersObject.tags"
                  :items="getFiltersList('MEET_TAGS')"
                  label="Meet tags"
                  item-value="node.valName"
                  item-text="node.valName"
                  outlined
                  hide-details
                  dense
                  class="mt-2"
                >
                  <template v-slot:append>
                    <v-icon @click="filtersObject.tags = ''">fa-times</v-icon>
                  </template>
                </v-select>
              </v-list-item-title>
            </v-list-item>
            <!--Date filter item-->
            <v-list-item>
              <v-list-item-title>
                <v-menu
                  v-model="dateFilterModel"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model.trim="filtersObject.date"
                      label="Events start date"
                      prepend-icon="event"
                      v-on="on"
                      v-bind="attrs"
                      hide-details
                      readonly
                    >
                      <template v-slot:append>
                        <v-icon @click="filtersObject.date = ''"
                          >fa-times</v-icon
                        >
                      </template>
                    </v-text-field>
                  </template>
                  <v-date-picker
                    v-model.trim="filtersObject.date"
                    @input="dateFilterModel = false"
                  ></v-date-picker>
                </v-menu>
              </v-list-item-title>
            </v-list-item>
            <!--DateTo filter item-->
            <v-list-item>
              <v-list-item-title>
                <v-menu
                  v-model="dateToFilterModel"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model.trim="filtersObject.dateTo"
                      label="Events end date"
                      prepend-icon="event"
                      hide-details
                      v-on="on"
                      v-bind="attrs"
                      readonly
                    >
                      <template v-slot:append>
                        <v-icon @click="filtersObject.dataTo = ''"
                          >fa-times</v-icon
                        >
                      </template>
                    </v-text-field>
                  </template>
                  <v-date-picker
                    v-model.trim="filtersObject.dateTo"
                    @input="dateToFilterModel = false"
                  ></v-date-picker>
                </v-menu>
              </v-list-item-title>
            </v-list-item>
          </v-list>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" block @click="resetFilters"> Reset </v-btn>
          </v-card-actions>
        </v-card>
      </v-menu>

      <v-btn
        color="primary"
        dark
        class="addNewEvent_btn mb-2"
        fab
        @click="toggle = !toggle"
      >
        <v-icon>fa-plus</v-icon>
      </v-btn>

      <!--Add new event dialog-->
      <v-dialog
        v-model="dialog"
        :retain-focus="false"
        max-width="700px"
        v-if="user"
        style="z-index: 1000 !important"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="primary"
            dark
            v-show="toggle"
            class="addNewEvent_btn mb-2"
            v-bind="attrs"
            v-on="on"
            fab
          >
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on">fa fa-briefcase</v-icon>
              </template>
              <span>Add Meet</span>
            </v-tooltip>
          </v-btn>
        </template>
        <meetForm
          :formTitle="formTitle"
          :index="editedIndex"
          :editData="dataToEdit"
          @close-form="close"
        />
      </v-dialog>
      <!--Add new club dialog-->
      <v-dialog
        v-show="toggle"
        v-model="dialogClub"
        :retain-focus="false"
        max-width="700px"
        v-if="user"
        style="z-index: 1000 !important"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="primary"
            dark
            v-show="toggle"
            class="addNewEvent_btn mb-2"
            v-bind="attrs"
            v-on="on"
            fab
          >
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on">fa-cubes</v-icon>
              </template>
              <span>Add Club</span>
            </v-tooltip>
          </v-btn>
        </template>
        <clubForm
          :formTitle="formTitleClub"
          :index="editedIndexClub"
          :editData="dataToEditClub"
          @close-club="closeClub"
        />
      </v-dialog>

      <!--Get info dialog-->
      <v-dialog
        v-model="infoDialog"
        :retain-focus="false"
        max-width="700px"
        style="z-index: 1000 !important"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on" fab>
            <v-icon>fa-info</v-icon>
          </v-btn>
        </template>
        <v-card>
          <v-card-title class="text-h5 grey lighten-2">
            Important information
          </v-card-title>

          <v-card-text>
            <ol>
              <li>You must be logged-in to add map content.</li>
              <li>
                If you want to know or create meet from whatever point on the
                map, you can double click to the map spot and choose your own
                action: either copy coordinates or create object from selected
                location
              </li>
              <li>Object on the map assumes either sport meet or facility</li>
            </ol>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="infoDialog = false">
              I understand
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!--zen mode toogler-->
      <v-btn fab @click="toogleZenMode" color="primary">
        <v-icon color="white" v-if="this.$store.getters.hasZenMode">
          fa-expand
        </v-icon>
        <v-icon v-else> fa-compress </v-icon>
      </v-btn>
    </div>
    <l-map
      v-if="!this.$store.getters.loading"
      :zoom.sync="zoom"
      :center="center"
      :bounds="bounds"
      :maxBounds="maxBounds"
      :options="mapOptions"
      :min-zoom="minZoom"
      :max-zoom="maxZoom"
      style="height: 100%"
      @dblclick="getInfo"
      @update:center="centerUpdate"
      @update:zoom="zoomUpdate"
      ref="myMap"
      class="meetMap"
    >
      <v-geosearch :options="geosearchOptions"></v-geosearch>
      <l-tile-layer :url="url" :attribution="attribution" />
      <l-marker-cluster>
        <l-marker
          v-for="facility in this.$store.getters.getFacilities"
          :key="facility.node.facilityId"
          :visible="true"
          :draggable="false"
          :lat-lng="{
            lat: facility.node.latitude,
            lng: facility.node.longitude
          }"
        >
          <l-icon
            :icon-size="[30, 30]"
            :icon-anchor="[10, 15]"
            class-name="someIcon"
          >
            <img
              :src="require(`../../../../../public/assets/img/facility.svg`)"
            />
          </l-icon>
          <l-popup>
            <v-list>
              <v-list-item>
                <v-list-item-title>
                  {{ facility.node.desc }}
                </v-list-item-title>
              </v-list-item>
            </v-list>
            <v-menu offset-x left nudge-left="15">
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="primary" dark v-bind="attrs" block v-on="on">
                  Actions
                </v-btn>
              </template>
              <v-list>
                <v-list-item>
                  <v-list-item-title>
                    <v-btn
                      block
                      color="primary"
                      @click="copyCoords(facility.node)"
                    >
                      Copy coordinates
                    </v-btn>
                  </v-list-item-title>
                </v-list-item>
                <v-list-item v-if="user && user.role === 'Administrator'">
                  <v-list-item-title>
                    <v-btn
                      block
                      color="primary"
                      @click="addMeetInCurrentFacility(facility.node)"
                    >
                      Add new meet here
                    </v-btn>
                  </v-list-item-title>
                </v-list-item>
                <v-list-item v-if="user && user.role === 'Administrator'">
                  <v-list-item-title>
                    <v-btn
                      block
                      color="primary"
                      @click="deleteFacility(facility.node.facilityId)"
                    >
                      Delete facility
                    </v-btn>
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </l-popup>
          <l-tooltip :content="facility.node.name" />
        </l-marker>
        <l-marker
          v-for="club in clubsMarkers"
          :key="club.node.clubName"
          :visible="true"
          :draggable="false"
          :lat-lng="{ lat: club.node.latitude, lng: club.node.longitude }"
        >
          <l-icon
            :icon-size="[20, 20]"
            :icon-anchor="[10, 15]"
            class-name="someIcon"
          >
            <img
              class="icon_background"
              :src="
                require(`../../../../../public/assets/img/IconsSports/${getCurrentSportType(
                  club.node
                )}`)
              "
            />

            <!-- <img
              :src="require(`../../../../../public/assets/img/club.svg`)
              "
            /> -->
          </l-icon>
          <l-popup>
            <v-list>
              <v-list-item>
                <v-list-item-title>
                  {{ club.node.clubDesc }}
                </v-list-item-title>
              </v-list-item>
            </v-list>
            <v-menu offset-x left nudge-left="15">
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="primary" dark v-bind="attrs" block v-on="on">
                  Actions
                </v-btn>
              </template>
              <v-list>
                <v-list-item>
                  <v-list-item-title>
                    <v-btn block color="primary" @click="copyCoords(club.node)">
                      Copy coordinates
                    </v-btn>
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </l-popup>
          <l-tooltip :content="club.node.clubName" />
        </l-marker>
        <l-marker
          v-for="(marker, index) in markers"
          :key="index"
          :visible="true"
          :draggable="false"
          :lat-lng="{ lat: marker.latitude, lng: marker.longitude }"
        >
          <l-icon
            :icon-size="[30, 30]"
            :icon-anchor="[10, 15]"
            class-name="someIcon"
          >
            <img
              :src="
                require(`../../../../../public/assets/img/${getCurrentIcon(
                  marker.meetType
                )}.svg`)
              "
            />
          </l-icon>
          <l-popup>
            <v-list>
              <v-list-item>
                <v-list-item-title>
                  {{ marker.meetDesc }}
                </v-list-item-title>
              </v-list-item>
            </v-list>
            <v-menu offset-x left nudge-left="15">
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="primary" dark v-bind="attrs" block v-on="on">
                  Actions
                </v-btn>
              </template>
              <v-list>
                <v-list-item>
                  <v-list-item-title>
                    <v-btn block color="primary" @click="copyCoords(marker)">
                      Copy coordinates
                    </v-btn>
                  </v-list-item-title>
                </v-list-item>
                <v-list-item v-if="user && user.role === 'Administrator'">
                  <v-list-item-title>
                    <v-btn block color="primary" @click="editMeet(marker)">
                      Edit meet
                    </v-btn>
                  </v-list-item-title>
                </v-list-item>
                <v-list-item v-if="user && user.role === 'Administrator'">
                  <v-list-item-title>
                    <v-btn
                      block
                      color="primary"
                      @click="deleteMeet(marker.meetId)"
                    >
                      Delete meet
                    </v-btn>
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </l-popup>
          <l-tooltip :content="marker.meetName" />
        </l-marker>
      </l-marker-cluster>
    </l-map>
    <!--Loading dialog-->
    <MapBottomSheet
      v-if="user"
      :showBottomSheet="bottomSheet"
      @hide-sheet="bottomSheet = $event"
      @add-meet-with-coords="addMeetFrom($event)"
      :data="dataToEdit"
    />
  </div>
</template>
<script>
//TODO Drop logic on small part
import { latLngBounds, latLng } from "leaflet";
import { mapGetters, mapActions } from "vuex";
import VGeosearch from "vue2-leaflet-geosearch";
import { OpenStreetMapProvider } from "leaflet-geosearch";
import meetForm from "@/components/forms/meetForm";
import clubForm from "@/components/forms/NewClubForm";
import { mapMethods } from "@/mixins/map";
import MapBottomSheet from "@/components/views/common/Map/MapBottomSheet";
import MapEventDetails from "@/components/views/common/Map/MapEventDetails";

export default {
  mixins: [mapMethods],
  components: {
    VGeosearch,
    meetForm,
    clubForm,
    MapEventDetails,
    MapBottomSheet
  },
  data() {
    return {
      filtersObject: {
        league: "",
        country: "",
        date: "",
        dateTo: "",
        sport: "",
        event: "",
        tags: ""
      },
      resetFiltersData: {
        league: "",
        country: "",
        date: "",
        dateTo: "",
        sport: "",
        event: "",
        tags: ""
      },
      toggle: false,
      bottomSheet: false,
      bounds: latLngBounds([
        [83.21569268984952, -170.88546752929688],
        [-82.90682922643165, 216.31805419921875]
      ]),
      maxBounds: latLngBounds([
        [83.21569268984952, -170.88546752929688],
        [-82.90682922643165, 216.31805419921875]
      ]),
      infoDialog: false,
      countryFilter: "",
      dateFilterModel: false,
      dateFilter: "",
      dateToFilterModel: false,
      dateToFilter: "",
      dataToEdit: false,
      dataToEditClub: false,
      settingsDialog: false,
      selectedEvent: 0,
      editedIndex: -1,
      editedIndexClub: -1,
      zoom: 12,
      dialog: false,
      dialogClub: false,
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      currentZoom: 11.5,
      currentCenter: latLng(47.74305593139867, 9.434966974610118),
      mapOptions: {},
      minZoom: 2.4,
      maxZoom: 20,
      showMap: true,
      eventModel: "",
      leagueModel: "",
      sportType: ""
    };
  },
  mounted() {
    setTimeout(() => {
      const resetBtn = document.querySelector(".reset");
      resetBtn.innerHTML =
        "<i class='v-icon notranslate fa fa-times theme--light light-blue--text text--darken-3'></i>";
    }, 100);
  },
  computed: {
    geosearchOptions() {
      return {
        provider: new OpenStreetMapProvider(),
        autocomplete: true,
        autoClose: true,
        style: this.$vuetify.breakpoint.mdAndUp ? "bar" : "button"
      };
    },
    hasMarkers() {
      return this.markers && this.markers.length > 0;
    },
    center() {
      if (this.hasMarkers) {
        const { latitude, longitude } = this.markers;
        return latLng(latitude, longitude);
      } else {
        return latLng(47.41322, -1.219482);
      }
    },
    ...mapGetters(["meets", "categoryValue", "getLeagues", "user", "clubs"]),
    clubsMarkers() {
      if (this.clubs.length > 0) {
        return this.clubs.filter(c => c.node.latitude && c.node.longitude);
      }

      return [];
    },
    markers() {
      if (this.meets.edges && this.$store.getters.getFacilities.length > 0) {
        let meetsWithFacilityId = this.meets.edges.filter(
          el => el.node.facilityId > 0
        );

        return meetsWithFacilityId
          .map(el => {
            let currentFacility = this.$store.getters.getFacilities.find(
              fEl => +fEl.node.facilityId === el.node.facilityId
            );
            if (currentFacility.node) {
              let {
                latitude,
                longitude,
                address,
                countryId
              } = currentFacility.node;

              return {
                ...el.node,
                latitude,
                longitude,
                meetAddress: address,
                countryId
              };
            }

            return {
              ...el.node
            };
          })
          .filter(meet => {
            // ? get league name from leagues by meet league seqno
            let leagueName = this.leagueNames.filter(
              l => +l.node.seqno === +meet.leagueSeqno
            )[0].node.name;
            if (
              meet.latitude &&
              meet.longitude &&
              meet.meetName.includes(this.filtersObject.event) &&
              // ? if league name after filters !== false || null || undefinde => compare with filters league else
              // ? get meet with leagueSeqno. Currently this is a shit code but any way :)
              (leagueName
                ? JSON.stringify(leagueName).includes(this.filtersObject.league)
                : meet.leagueSeqno) &&
              JSON.stringify(meet.sport).includes(this.filtersObject.sport) &&
              JSON.stringify(meet.countryId).includes(
                this.filtersObject.country
              ) &&
              String(JSON.parse(meet.tag)).includes(this.filtersObject.tags) &&
              meet.meetDate.includes(this.filtersObject.date) &&
              meet.meetDateTo.includes(this.filtersObject.dateTo)
            ) {
              return meet;
            }
          });
      } else {
        return [];
      }
    },
    leagueNames() {
      return this.getLeagues || [];
    },
    eventsBadgeColor() {
      return this.hasMarkers ? "light-blue darken-4" : "red";
    },
    formTitle() {
      return this.editedIndex === -1 ? "New Meet" : "Edit meet";
    },
    formTitleClub() {
      return this.editedIndexClub === -1 ? "New Club" : "Edit Club";
    }
  },
  methods: {
    ...mapActions(["deleteCurrentMeet", "removeFacility"]),
    toogleZenMode() {
      this.$store.commit("toogleZenMode");
    },
    addMeetInCurrentFacility(facility) {
      this.dataToEdit = {
        facilityId: +facility.facilityId
      };
      this.dialog = true;
    },
    // TODO Take out this logic to helper file
    /**
     * @param {String} category array filtered by this value
     * you can get needed value in Artifacts component
     */
    getFiltersList(category) {
      if (this.categoryValue.edges) {
        return this.categoryValue.edges.filter(
          f => f.node.category.catName === category
        );
      } else {
        return [];
      }
    },
    getCurrentIcon(meetType) {
      //TODO In future, when we able to add meetType category to
      // artifacts list we must check for meetType throught cycle
      // and if it in it, wee can set current icon to him,
      // in other way we set default icon

      // * All meetType name === svg file name.
      switch (meetType) {
        case "training":
          return "camp";
        case "meetup":
          return meetType;
        case "fun":
          return meetType;
        case "competition":
          return meetType;
        case "camp":
          return meetType;
        default:
          return "default_marker";
      }
    },
    getCurrentSportType(node) {
      if (node.team.edges.length > 0) {
        let valueArr = node.team.edges.map(function(item) {
          return item.node.sportType;
        });
        const setDubl = new Set(valueArr);
        if (setDubl.length > 0 || node.team.edges[0].node.sportType == 0) {
          return "default.png";
        } else return node.team.edges[0].node.sportType.toLowerCase() + ".png";
      } else {
        return "tennis.png";
      }
    },
    /**
     * @param {Object{latitude, longitude}}
     */
    addMeetFrom(data) {
      this.bottomSheet = false;
      // * Important part it's add updatedSourse.
      // * Without it addNewMeet action doesn't work
      this.dataToEdit = Object.assign({}, data);
      this.dialog = true;
      console.log(data);
    },
    addClubFrom(data) {
      this.dataToEditClub = Object.assign({}, data);
      this.dialogClub = true;
    },
    resetFilters() {
      this.filtersObject = Object.assign({}, this.resetFiltersData);
    },
    close() {
      this.dialog = false;
      this.editedIndex = -1;
      this.dataToEdit = false;
      this.dataToEditClub = false;
    },
    closeClub() {
      this.dialogClub = false;
      this.$emit("close-club");
      this.editedIndexClub = -1;
    },
    editMeet(item) {
      this.dataToEdit = Object.assign({}, item);
      this.editedIndex = 1;
      this.dialog = true;
    },
    editClub(item) {
      this.dataToEditClub = Object.assign({}, item);
      this.editedIndex = 1;
      this.dialog = true;
    },
    deleteMeet(id) {
      this.deleteCurrentMeet({ meetId: id })
        .then(() => {
          this.$toast.error("Meet has been deleted");
        })
        .catch(error => {
          console.error(error);
        });
    },
    copyCoords(item) {
      navigator.clipboard
        .writeText(`${item.latitude}, ${item.longitude}`)
        .then(() => {
          this.$toast.success("Coordinates has been copied");
        })
        .catch(error => {
          console.error(error);
          this.$toast.error("Something went wrong((");
        });
    },
    resetEvent(e) {
      console.log(e);
      this.filtersObject.league = "";
    },
    getInfo(e) {
      this.dataToEdit = {
        latitude: e.latlng.lat,
        longitude: e.latlng.lng
      };
      this.bottomSheet = true;
    },
    zoomUpdate(zoom) {
      this.currentZoom = zoom;
    },
    centerUpdate(center) {
      this.currentCenter = center;
    },
    convertCoord(lat, long) {
      return latLng(lat, long);
    },
    fly(item) {
      console.log(item);
      this.$refs.myMap.mapObject.flyTo([item.latitude, item.longitude], 16, {
        duration: 5
      });
    }
  },
  async created() {
    Promise.all([
      await this.$store.dispatch("allMeets"),
      await this.$store.dispatch("getAllLeagues"),
      await this.$store.dispatch("allClubs"),
      await this.$store.dispatch("allFacility")
    ]).then(() => {
      console.log(this.meets.edges.filter(el => el.node.facilityId > 0));
    });
  }
};
</script>
<style lang="scss">
@import "~leaflet.markercluster/dist/MarkerCluster.css";
@import "~leaflet.markercluster/dist/MarkerCluster.Default.css";
.leaflet-control-geosearch {
  .reset {
    margin-top: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  form {
    border: 2px solid #0277bd !important;
  }
}

.meetMap {
  .leaflet-popup-content-wrapper {
    border-radius: 4px;
  }
  .leaflet-popup-content {
    margin: 10px 10px;
  }
}

.someIcon {
  img,
  span {
    width: 40px !important;
    height: 40px !important;
  }
}

.map_events_list {
  max-height: 600px;
  overflow: auto;
}

.map_control-btns {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
}
.hover-item-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
